import React, { useEffect, useState } from 'react';
import {
  Form,
  Input,
  Button,
  Row,
  Col,
  InputNumber,
  message,
  Typography,
  Card,
  Divider,
  Modal,
} from 'antd';
import axios from 'axios';

const { Title, Paragraph } = Typography;

function App() {
  const [form] = Form.useForm();
  const [ipAddress, setIpAddress] = useState('');
  const [isModalVisible, setIsModalVisible] = useState(false); // Modal kontrolü
  const [paymentUrl, setPaymentUrl] = useState(''); // Ödeme URL'sini saklamak için

  // IP adresini almak için
  useEffect(() => {
    const fetchIpAddress = async () => {
      try {
        const response = await axios.get('https://api64.ipify.org?format=json');
        setIpAddress(response.data.ip); // IP adresini state'e kaydet
      } catch (error) {
        console.error('Error fetching IP address:', error);
        message.error('IP adresi alınamadı!');
      }
    };
    fetchIpAddress();
  }, []);

  const onFinish = async values => {
    const formDataWithIp = { ...values, customerIpAddress: ipAddress };
    console.log('Form Values with IP Address:', formDataWithIp);

    try {
      const response = await axios.post(
        'https://uvsbackend-7107e809a91f.herokuapp.com/trustedpayment',
        formDataWithIp
      );

      console.log('Response:', response.data);

      if (response.data.data.PaymentData.PaymentUrl) {
        const paymentUrl = response.data.data.PaymentData.PaymentUrl;
        setPaymentUrl(paymentUrl); // Payment URL'sini state'e kaydet
        setIsModalVisible(true); // Modal'ı aç
        message.success('Ödeme sayfası modal içinde açılıyor...');
        form.resetFields(); // Form verilerini temizle
      } else {
        message.error('Ödeme URL bulunamadı!');
      }
    } catch (error) {
      console.error('Error:', error);
      message.error('Ödeme isteği başarısız oldu!');
    }
  };

  const handleCancel = () => {
    setIsModalVisible(false); // Modal'ı kapat
  };

  return (
    <>
      <Row justify="center" style={{ marginTop: '50px' }}>
        <Col xs={22} sm={20} md={12} lg={10}>
          <Card
            style={{
              borderRadius: '10px',
              boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
            }}
          >
            <Title
              level={2}
              style={{ textAlign: 'center', fontWeight: 'bold' }}
            >
              Üsküdar Valide Sultan
              <br />
              Eğitim ve Kültüre Yardım Derneği
              <br />
            </Title>

            <Form
              form={form}
              name="donation_form"
              onFinish={onFinish}
              layout="vertical"
              style={{ marginBottom: '30px' }}
            >
              <Form.Item
                name="customerName"
                label="İsim"
                rules={[{ required: true, message: 'Lütfen adınızı girin!' }]}
              >
                <Input placeholder="Adınız" />
              </Form.Item>

              <Form.Item
                name="customerSurname"
                label="Soyisim"
                rules={[
                  { required: true, message: 'Lütfen soyadınızı girin!' },
                ]}
              >
                <Input placeholder="Soyadınız" />
              </Form.Item>

              <Form.Item
                name="customerEmail"
                label="E-posta"
                rules={[
                  {
                    required: true,
                    message: 'Lütfen e-posta adresinizi girin!',
                  },
                  {
                    type: 'email',
                    message: 'Geçerli bir e-posta adresi girin!',
                  },
                ]}
              >
                <Input placeholder="E-posta" />
              </Form.Item>

              <Form.Item
                name="customerPhone"
                label="Telefon Numarası"
                rules={[
                  {
                    required: true,
                    message: 'Lütfen telefon numaranızı girin!',
                  },
                  {
                    pattern: /^[0-9]{10}$/,
                    message: 'Telefon numarası 10 rakam olmalıdır',
                  },
                ]}
              >
                <Input
                  placeholder="Telefon numarasının başında '0' olmadan"
                  maxLength={10}
                />
              </Form.Item>

              <Form.Item
                name="price"
                label="Bağış Miktarı (TL)"
                rules={[
                  { required: true, message: 'Lütfen bağış miktarını girin!' },
                ]}
              >
                <InputNumber
                  min={1}
                  style={{ width: '100%' }}
                  placeholder="Bağış Miktarı"
                />
              </Form.Item>

              <Form.Item>
                <Button
                  type="primary"
                  htmlType="submit"
                  style={{ width: '100%' }}
                >
                  Bağış
                </Button>
              </Form.Item>
            </Form>

            <Divider />

            <div style={{ textAlign: 'center' }}>
              <img
                src="https://logos-world.net/wp-content/uploads/2020/09/Mastercard-Logo.png"
                alt="MasterCard"
                style={{ height: '30px', margin: '0 10px' }}
              />
              <img
                src="https://upload.wikimedia.org/wikipedia/commons/5/5e/Visa_Inc._logo.svg"
                alt="Visa"
                style={{ height: '30px', margin: '0 10px' }}
              />
              <img
                src="https://image.troyodeme.com/troy-logo-14.png"
                alt="Troy"
                style={{ height: '30px', margin: '0 10px' }}
              />
              <img
                src="https://weepay.co/blog/wp-content/uploads/2020/08/3d-secure-667x334-1.png"
                alt="3D Security"
                style={{ height: '30px', margin: '0 10px' }}
              />
              <img
                src="https://www.pngall.com/wp-content/uploads/2/SSL-PNG-Image-File.png"
                alt="SSL"
                style={{ height: '30px', margin: '0 10px' }}
              />
            </div>
            <Divider />
            <Paragraph style={{ textAlign: 'center' }}>
              © 2024 Üsküdar Valide Sultan Eğitim ve Kültüre Yardım Derneği.
              <br />
              Tüm hakları saklıdır.
            </Paragraph>
          </Card>
        </Col>
      </Row>

      {/* Modal for Payment */}
      <Modal
        title="Ödeme Sayfası"
        visible={isModalVisible}
        onCancel={handleCancel}
        footer={null}
        width={1500}
        height={1000}
      >
        {paymentUrl && (
          <iframe
            src={paymentUrl}
            title="Payment"
            width="100%"
            height="700px"
            frameBorder="0"
          />
        )}
      </Modal>
    </>
  );
}

export default App;
